import StreamedList from './StreamedList';
import StreamedListContainer from './StreamedList.container';
export default StreamedListContainer(StreamedList);
//# sourceMappingURL=index.js.map